export const ANEXO_REMOCAO_TITLE = "Remover arquivo";
export const ANEXO_REMOCAO_CONFIRMAR_LABEL = "Remover";
export const ANEXO_REMOCAO_CANCELAR_LABEL = "Cancelar";
